import React from 'react';
import { useTheme } from './ThemeProvider';

interface DopaLogoProps {
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  withText?: boolean;
  className?: string;
}

const DopaLogo: React.FC<DopaLogoProps> = ({
  size = 'md',
  withText = true,
  className = '',
}) => {
  const { theme } = useTheme();
  const isDark = theme === 'dark';

  // Size mappings for the logo container
  const sizeClasses = {
    xs: 'w-6 h-6',
    sm: 'w-8 h-8',
    md: 'w-12 h-12',
    lg: 'w-20 h-20',
    xl: 'w-28 h-28',
  };

  // Size mappings for the text
  const textSizeClasses = {
    xs: 'text-xs',
    sm: 'text-sm',
    md: 'text-lg',
    lg: 'text-xl',
    xl: 'text-2xl',
  };

  return (
    <div className={`flex items-center ${className}`}>
      <div className={`${sizeClasses[size]} relative flex items-center justify-center`}>
        <svg 
          viewBox="0 0 120 120" 
          fill="none" 
          xmlns="http://www.w3.org/2000/svg"
          className="w-full h-full"
        >
          <defs>
            <radialGradient id="dopaGradient" cx="50%" cy="50%" r="50%">
              <stop offset="0%" stopColor={isDark ? "#FEECDC" : "#FEECDC"} />
              <stop offset="100%" stopColor={isDark ? "#FCD9BD" : "#FCD9BD"} />
            </radialGradient>
            <filter id="dopaShadow" x="-10%" y="-10%" width="130%" height="130%">
              <feDropShadow dx="0" dy="3" stdDeviation="5" floodColor={isDark ? "#C18D53" : "#FCD9BD"} floodOpacity="0.3" />
            </filter>
          </defs>
          {/* D-shaped path with rounded corners on the flat side */}
          <path 
            d="M60,20 
               C80,20 95,40 95,60 
               C95,80 80,100 60,100 
               C50,100 40,100 40,100 
               C35,100 30,95 30,90 
               L30,30 
               C30,25 35,20 40,20 
               Z" 
            fill="url(#dopaGradient)"
            stroke={isDark ? "#FCD9BD" : "#FDBA8C"}
            strokeWidth="1.5"
            filter="url(#dopaShadow)"
          />
          <circle cx="60" cy="60" r="20" fill={isDark ? "#FDBA8C" : "#FEECDC"} opacity="0.15" />
          <circle cx="45" cy="45" r="5" fill={isDark ? "#FEF7F0" : "#FEF7F0"} opacity="0.25" />
        </svg>
      </div>
      
      {withText && (
        <span className={`ml-2 font-light ${textSizeClasses[size]} ${isDark ? 'text-peach-300' : 'text-peach-600'}`}>
          Dopa
        </span>
      )}
    </div>
  );
};

export default DopaLogo;